/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkClockOutData
 */
export interface BulkClockOutData {
    /**
     * 
     * @type {Array<number>}
     * @memberof BulkClockOutData
     */
    employeeIds: Array<number>;
    /**
     * 
     * @type {Date}
     * @memberof BulkClockOutData
     */
    endTime?: Date;
}

/**
 * Check if a given object implements the BulkClockOutData interface.
 */
export function instanceOfBulkClockOutData(value: object): value is BulkClockOutData {
    if (!('employeeIds' in value) || value['employeeIds'] === undefined) return false;
    return true;
}

export function BulkClockOutDataFromJSON(json: any): BulkClockOutData {
    return BulkClockOutDataFromJSONTyped(json, false);
}

export function BulkClockOutDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkClockOutData {
    if (json == null) {
        return json;
    }
    return {
        
        'employeeIds': json['employeeIds'],
        'endTime': json['endTime'] == null ? undefined : (new Date(json['endTime'])),
    };
}

  export function BulkClockOutDataToJSON(json: any): BulkClockOutData {
      return BulkClockOutDataToJSONTyped(json, false);
  }

  export function BulkClockOutDataToJSONTyped(value?: BulkClockOutData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employeeIds': value['employeeIds'],
        'endTime': value['endTime'] == null ? undefined : ((value['endTime']).toISOString()),
    };
}

